(() => {
  if (window.cbPurchaseSpaceReady) return;
  window.cbPurchaseSpaceReady = true;
  const sessionKey = 'cb-offer-dismissed';
  const registered = new WeakSet();
  const shadowObservers = new Set();
  // Keep mobile help available in the footer without floating over shopping content.
  const supportArea = document.querySelector('.cb-footer-links');
  const supportObserver = supportArea ? new IntersectionObserver(([entry]) => {
    document.body.classList.toggle('cb-support-area-visible', entry.isIntersecting);
  }) : null;
  if (supportArea) supportObserver.observe(supportArea);
  const styles = `
    @media (max-width: 749px) {
      [data-form-root][data-current-step="tease"] { display: none !important; }
    }
    :host([data-cb-offer-dismissed]) [data-form-root][data-current-step="tease"] { display: none !important; }
  `;
  function wireOffers() {
    document.querySelectorAll('shopify-forms-embed').forEach((host) => {
      if (!host.shadowRoot || registered.has(host)) return;
      registered.add(host);
      try {
        if (sessionStorage.getItem(sessionKey) === 'true') host.dataset.cbOfferDismissed = 'true';
      } catch {}
      const ensureStyle = () => {
        if (host.shadowRoot.querySelector('[data-cb-offer-style]')) return;
        const style = document.createElement('style');
        style.dataset.cbOfferStyle = 'true';
        style.textContent = styles;
        host.shadowRoot.appendChild(style);
      };
      ensureStyle();
      const shadowObserver = new MutationObserver(ensureStyle);
      shadowObserver.observe(host.shadowRoot, { childList: true, subtree: true });
      shadowObservers.add({ host, observer: shadowObserver });
      host.shadowRoot.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target?.closest('[aria-label="Close modal"]')) return;
        host.dataset.cbOfferDismissed = 'true';
        try { sessionStorage.setItem(sessionKey, 'true'); } catch {}
      }, { capture: true });
    });
  }
  wireOffers();
  customElements.whenDefined('shopify-forms-embed').then(wireOffers);
  const observer = new MutationObserver(wireOffers);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pagehide', () => {
    observer.disconnect();
    supportObserver?.disconnect();
    shadowObservers.forEach(({ observer: shadowObserver }) => shadowObserver.disconnect());
  });
  window.addEventListener('pageshow', () => {
    wireOffers();
    if (supportArea) supportObserver.observe(supportArea);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    shadowObservers.forEach(({ host, observer: shadowObserver }) => {
      if (host.isConnected) shadowObserver.observe(host.shadowRoot, { childList: true, subtree: true });
    });
  });
})();
